import { useState, useEffect, Fragment } from "react";
import { useParams } from 'react-router-dom';
import { Box, Typography, Alert, CircularProgress } from '@mui/material';
import { decodeShareLink } from '../utils/shareUtils';
import BasePotreeViewer from './BasePotreeViewer';

function PublicPotreeViewer() {
  const { shareId } = useParams();
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [decodedData, setDecodedData] = useState(null);

  useEffect(() => {
    const initViewer = async () => {
      try {
        // Decode the shareId to get the presigned URLs
        const data = decodeShareLink(shareId);
        setDecodedData(data);
        setLoading(false);
      } catch (e) {
        console.error('Error loading point cloud:', e);
        setError('Failed to load point cloud. The share link may be expired or invalid.');
        setLoading(false);
      }
    };

    initViewer();
  }, [shareId]);

  const handleError = (error) => {
    console.error('Error in Potree viewer:', error);
    setError('Failed to load point cloud. The share link may be expired or invalid.');
    setLoading(false);
  };

  const handleSuccess = () => {
    setLoading(false);
  };

  if (loading) {
    return (
      <Fragment>
        <Box 
          display="flex" 
          justifyContent="center" 
          alignItems="center" 
          height="100vh"
          flexDirection="column"
          gap={2}
          style={{ position: 'fixed', top: 0, left: 0, width: '100%', zIndex: 1000 }}
        >
          <CircularProgress size={60} />
          <Typography variant="h6">Loading point cloud...</Typography>
        </Box>
      </Fragment>
    );
  }

  if (error) {
    return (
      <Fragment>
        <Box 
          display="flex" 
          justifyContent="center" 
          alignItems="center" 
          height="100vh"
          padding={3}
          style={{ position: 'fixed', top: 0, left: 0, width: '100%', zIndex: 1000 }}
        >
          <Alert severity="error" sx={{ maxWidth: 500 }}>
            <Typography variant="h6" gutterBottom>Error Loading Point Cloud</Typography>
            <Typography>{error}</Typography>
          </Alert>
        </Box>
      </Fragment>
    );
  }

  if (!decodedData) {
    return null;
  }

  return (
    <BasePotreeViewer
      filename={decodedData.filename}
      description={decodedData.description}
      metadata={decodedData.metadata}
      hierarchy={decodedData.hierarchy}
      octree={decodedData.octree}
      showTranslations={false}
      onError={handleError}
      onSuccess={handleSuccess}
    />
  );
}

export default PublicPotreeViewer;